import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { withPixelLineHeight } from '../../../styles/functions.web';
import { useSelector } from 'react-redux';
import { getKnockingParticipants } from '../../../../lobby/functions';
import { isLocalParticipantModerator } from '../../../participants';
const useStyles = makeStyles()(theme => {
    return {
        badge: {
            backgroundColor: theme.palette.default02,
            borderRadius: '100%',
            height: '18px',
            minWidth: '18px',
            color: theme.palette.text01,
            ...withPixelLineHeight(theme.typography.labelBold),
            pointerEvents: 'none',
            position: 'absolute',
            // right: '-4px',
            right: '12px',
            top: '-3px',
            textAlign: 'center',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '1px 0',
            margin: '0 1px',
            '&.countLarge': {
                borderRadius: '40px',
                right: '-2px'
            }
        },
        badgeCount: {
            backgroundColor: theme.palette.default00,
            borderRadius: '50%',
            display: 'block',
            height: '16px',
            minWidth: '16px',
            margin: '2px',
            '&.countLargeNumber': {
                borderRadius: '40px',
                padding: '0 4px'
            }
        }
    };
});
/**
 * Component badge counter toolbox item
 * @param count
 * @param backgroundColor
 * @returns
 */
const BadgeCounter = ({ count, backgroundColor, textColor }) => {
    const { classes } = useStyles();
    const isLargeCount = count && count > 99;
    const isLocalModerator = isLocalParticipantModerator(APP.store.getState());
    const participants = useSelector(getKnockingParticipants);
    const totalParticipants = (count ? count : 0) + participants.length;
    const getStyles = () => {
        const defaultStyle = {};
        if (backgroundColor)
            defaultStyle.backgroundColor = backgroundColor;
        if (textColor)
            defaultStyle.color = textColor;
        return defaultStyle;
    };
    return React.createElement("span", { className: `${classes.badge} ${isLargeCount ? 'countLarge' : ''}` },
        React.createElement("span", { className: `${classes.badgeCount} ${isLargeCount ? 'countLargeNumber' : ''}`, style: getStyles() }, isLocalModerator ? totalParticipants : count));
};
export default BadgeCounter;
